import { useState } from "react";
import { Col, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

import { MoroccoForm } from "../NewForm/MoroccoForm";
import SuccessfullMessage from "../NewForm/SuccessfullMessage";

import "react-toastify/dist/ReactToastify.css";
import "../NewForm/flags.css";

import "./GodoForm.css"; // Assuming you have a CSS file for styling
import LanguageTranslation from "../NewForm/LanguageTranslation";
import FormTypes from "../NewForm/FormTypes";
import Loader from "./Loader";
import TempBanner from "./TempBanner";

const GodoForm = () => {
  const [submittedData, setSubmittedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("Corporate");

  const { t, i18n } = useTranslation();

  return (
    <div
      className="d-sm-flex IndividuallayoutContainer formDimission" // Full height container
    >
      <Col
        md={6}
        className={`position-relative p-0 ${submittedData ? "d-none" : "d-block"
          } d-sm-none`}
      >
        <TempBanner />
      </Col>

      {/* LEFT SCROLLABLE FORM COLUMN */}
      <Col
        md={6}
        className="scrollableFormSection" // scrollable left
      >
        {!submittedData && !loading ? (
          <>
            <div className="d-flex justify-content-center justify-content-lg-between">
              <a
                href="https://nafdak.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/nafdaq-logo.jpg`}
                  alt="logo"
                  className="d-none d-lg-block mt-2 mb-lg-4 mb-lg-0"
                  style={{ width: "70px", height: "70px", borderRadius: "12px" }}
                />
              </a>
              <div className="d-flex gap-4 mt-3 mt-lg-0 justify-content-center justify-content-sm-end align-items-center">
                <LanguageTranslation />
                <FormTypes className="logoCss" setFormType={setFormType} />
              </div>
            </div>

            <Row style={{ alignItems: "center", marginBottom: "8px" }}>
              <Col
                md={12}
                className={`${i18n.language === "ar" || i18n.language === "ir"
                  ? "text-end d-flex flex-column justify-content-end align-items-end"
                  : ""
                  } text-lg-start mt-4 mt-lg-2`}
              >
                <h3 className="fw-bold">{t("CreateYourAccount")}</h3>
                <p className="mb-0">{t("AchievingYourFinancialGoals")}</p>
              </Col>
            </Row>

            <MoroccoForm
              setSubmittedData={setSubmittedData}
              setLoading={setLoading}
            />
          </>
        ) : loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <Loader />
            {/* You can replace this with a spinner component */}
          </div>
        ) : (
          <SuccessfullMessage submittedData={submittedData} />
        )}
      </Col>

      {/* RIGHT STICKY IMAGE COLUMN */}
      <Col md={6} className="position-relative p-0 d-none d-sm-block">
        <div
          style={{
            position: "sticky",
            top: 0,
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <TempBanner />
        </div>
      </Col>

      <ToastContainer />
    </div>
  );
};

export default GodoForm;
